module.exports = __webpack_public_path__ + "img/bg_networking.ce20fccb.jpg";